export const VOICES = [
  { id: "marin", name: "Marin", description: "Animated and earnest" },
  { id: "cedar", name: "Cedar", description: "Open and upbeat" },
] as const;

export type VoiceId = (typeof VOICES)[number]["id"];

export const DEFAULT_VOICE: VoiceId = "marin";

export function resolveVoice(value: unknown): VoiceId {
  return VOICES.find((voice) => voice.id === value)?.id ?? DEFAULT_VOICE;
}
